import { render } from "./OfferFormView.vue?vue&type=template&id=40c30c96&scoped=true"
import script from "./OfferFormView.vue?vue&type=script&lang=js"
export * from "./OfferFormView.vue?vue&type=script&lang=js"

import "./OfferFormView.vue?vue&type=style&index=0&id=40c30c96&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c30c96"]])

export default __exports__